import React, { useEffect, useState } from "react";
import "../css/invoiceForm.css";
import GeneralInfo from "../components/GeneralInfo";
import AdmissionDetails from "../components/AdmissionDetails";
import CustomerInfo from "../components/CustomerInfo";
import Lines from "../components/Lines";
import CuM from "../components/CuM";
import Payment from "../components/Payment";
import CustomButton from "../../common_component/component/CustomButton";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import {
  calculateDiscountedPrice,
  validateDiscAmt,
} from "../helpers/_invoiceHelpers";
import TotalCount from "../components/TotalCount";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import BillingEmail from "../components/BillingEmail";
import CuModal from "../../common_component/component/CuModal";
import {
  useCreateItem,
  useSecureDeleteItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { useLocation, useNavigate } from "react-router-dom";
import { INVOICE_MENU_OPTIONS, initialState } from "../constants/_constant";
import { deepCopy } from "../../_helper/utils/utils";
import { useAtom } from "jotai";
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import { toast } from "react-toastify";
import InvoiceAttachment from "../components/InvoiceAttachment";
import moment from "moment";
import { MdExpandLess } from "react-icons/md";
import { MdExpandMore } from "react-icons/md";
import EmailTemplate from "../components/EmailTemplate";
import PGeneralInfo from "../components/PGeneralInfo";
import PLine from "../components/PLine";
import PInvoicePrint from "../components/PInvoicePrint";
import ReactDOMServer from "react-dom/server";
import InvoicePrint from "../components/InvoicePrint";
import { getImageURL } from "../../_helper/utils/image";
import { secureAxios } from "../../_helper/constant/auth";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { FaEye } from "react-icons/fa";

const InvoiceForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const { role_id } = useCurrentRole();
  // Accessing individual query parameters
  const editId = queryParams.get("editId");
  const viewId = queryParams.get("viewId");
  const billType = queryParams.get("bill_type");
  const { data, isInstitutionP, throwAppointment } = location.state || {
    data: {},
    throwAppointment: false,
    isInstitutionP: true,
  };
  const [showIcon, setShowIcon] = useState(true);
  const [isUplaod, setIsUpload] = useState(false);
  const [uploadedImageIds, setUploadedImageIds] = useState([]);
  const [isPrint, setIsPrint] = useState(false);
  const [isSend, setIsSend] = useState({ flag: false, invoicePdf: null });
  const [comment, setComment] = useState("");
  const [showUserList, setShowUserList] = useState(false);
  const [isInstitutionPatient, setIsInstitutionPatient] =
    useState(isInstitutionP);
  const [clinic] = useAtom(clinicAtom);
  const [options, setOptions] = useState({
    services: [],
    payment: [],
  });
  const [doctorSettings] = useAtom(doctorSettingAtom);
  const [isPDFLoading, setIsPDFLoading] = useState(false);

  const [lineLevelDisc, setLineLevelDisc] = useState(false);
  const [invoiceData, setInvoiceData] = useState(
    deepCopy({
      ...initialState,
      ...data,
      bill_type: billType,
      invoice_date: new Date(),
    })
  );
  const [pharmacyLines, setPharmacyLines] = useState([
    {
      // clinic_id: clinic?.id,
      // id: null,
      medicine_id: null,
      medicine_name: "",
      generic_name: "",
      quantity: 0,
      batch_no: [],
      uom: "",
      price: 0,
      discount: 0,
      discount_type: "percentage",
      total: 0,
    },
  ]);

  useEffect(() => {
    if (clinic) {
      setInvoiceData((prev) => ({ ...prev, clinic_id: clinic?.id }));
    }
  }, [clinic]);

  const { data: invoiceNo } = useItemsFilter(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    `?action=getNumberSequenceByname&clinic_id=${clinic?.id}&backend=True&transaction_type=${billType} INVOICE&bill_type=${billType}`,
    clinic?.id && billType && !editId && !viewId ? true : false,
    "invoice"
  );

  useEffect(() => {
    if (invoiceNo) {
      setInvoiceData((prev) => ({
        ...prev,
        invoice_no: invoiceNo?.invoice_number,
      }));
    }
  }, [invoiceNo]);

  const queryForPaymentOptions = `?action=getPaymentOptions&frontend=True&clinic_id=${clinic?.id}`;
  const { data: paymentOptions } = useItemsFilter(
    ApiEndPoint.PAYMENT_OPTIONS,
    queryForPaymentOptions,
    clinic?.id ? true : false
  );

  const viewInvoiceQuery = `?action=getBillingCreditInvoice&frontend=True&clinic_id=${
    clinic?.id
  }&id=${editId || viewId}`;

  const { data: editData } = useItemsFilter(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    viewInvoiceQuery,
    clinic?.id && (editId || viewId) ? true : false
  );

  useEffect(() => {
    if (paymentOptions) {
      const options = paymentOptions?.map((poption) => ({
        key: poption?.id,
        value: poption?.id,
        text: poption?.type,
      }));
      setOptions((prev) => ({ ...prev, payment: options }));
    }
  }, [paymentOptions]);

  const handleChange = (val, label) => {
    if (label === "discount") {
      let total = 0;
      total = invoiceData?.invoice_lines?.reduce(
        (accumulator, currentValue) => accumulator + currentValue?.total,
        0
      );
      if (billType === "PHARMACY") {
        total = pharmacyLines?.reduce(
          (accumulator, currentValue) => accumulator + currentValue?.total,
          0
        );
      }
      const type = invoiceData?.discount_type;
      const isValidate = validateDiscAmt(total, val, type);
      if (!isValidate) {
        return;
      } else {
        setInvoiceData((prev) => {
          const grandTotal = calculateDiscountedPrice(
            total,
            val,
            prev?.discount_type
          );
          const stateToUpdate = {
            discount: val,
            invoice_total: grandTotal,
          };
          return { ...prev, ...stateToUpdate };
        });
      }
      return;
    }
    setInvoiceData((prev) => ({ ...prev, [label]: val }));
  };

  const calculateTotal = (data) => {
    // to store total
    let maintotal = 0;
    let subtotal = 0;

    const updatedLines = [];
    for (let i of data) {
      //mainline calculation
      const { price, quantity, discount, discount_type, sub_lines } = i;
      const totalAmt = Number(price) * Number(quantity);
      const discountTotal = calculateDiscountedPrice(
        totalAmt,
        discount,
        discount_type
      );
      maintotal += Number(discountTotal);

      //subline calculation
      const subline = [];
      let singleSubTotal = 0;
      for (let j of sub_lines) {
        const { price, quantity, discount, discount_type } = j;
        const subtotalAmt = Number(price) * Number(quantity);
        const subdiscountTotal = calculateDiscountedPrice(
          subtotalAmt,
          discount,
          discount_type
        );
        subline.push({ ...j, total: subdiscountTotal });
        subtotal += Number(subdiscountTotal);
        singleSubTotal += Number(subdiscountTotal);
      }

      updatedLines.push({
        ...i,
        sub_lines: subline,
        total: Number(discountTotal) + Number(singleSubTotal),
      });
    }

    const total = Number(maintotal) + Number(subtotal);
    const discount = invoiceData?.discount;
    const discountType = invoiceData?.discount_type;

    const isValidate = validateDiscAmt(total, discount, discountType);

    let stateToUpdate = {
      invoice_lines: updatedLines,
    };

    if (isValidate) {
      const grandTotal = calculateDiscountedPrice(
        total,
        discount,
        discountType
      );
      stateToUpdate = {
        invoice_lines: updatedLines,
        invoice_total: grandTotal,
      };
    }

    // setInvoiceData((prev) => ({ ...prev, ...stateToUpdate }));
    return stateToUpdate;
  };

  useEffect(() => {
    if (editData) {
      // setUploadedImageIds(
      //   editData?.invoice_files?.map((file) => ({
      //     id: file?.id,
      //     name: file?.filename_download,
      //   })) || []
      // );

      setInvoiceData({
        id: editData?.id,
        invoice_no: editData?.invoice_no,
        invoice_total: editData?.invoice_total,
        slot_id: editData?.slot_id,
        bill_type: editData?.bill_type,
        pdf_invoice: editData?.pdf_invoice,
        opd: editData?.consultation_data
          ? {
              id: editData?.consultation_data?.id,
              opd_number: editData?.consultation_data?.opd_number,
              date: moment(
                editData?.consultation_data?.opd_date ||
                  editData?.consultation_data?.date_created
              ).format("DD MMMM YYYY"),
            }
          : { id: null, opd_number: "", date: moment().format("DD MMMM YYYY") },
        invoice_date: editData?.invoice_date,
        status: editData?.status,
        clinic_id: editData?.clinic_id,
        admission_details: editData?.admission_details,
        discount: editData?.discount,
        discount_type: editData?.discount_type,
        invoice_lines: editData?.invoice_lines,
        institution_customer: editData?.institution_customer,
        patient_details: editData?.patient_details,
        billing_credit_payments: [
          ...editData?.billing_credit_payments,
          {
            status: "Paid",
            received_payment: 0,
            transaction_date: "",
            transaction_details: "",
            payment_mode: { id: 2, type: "By cash" },
          },
        ],
      });
      if (billType === "PHARMACY") {
        setPharmacyLines(editData?.pharmacy_lines);
      }
      setIsInstitutionPatient(editData?.institution);
    }
  }, [editData]);

  const validateInvoiceForm = (type = "submit") => {
    if (isInstitutionPatient && !invoiceData?.institution_customer?.id) {
      toast.error("Please select customer");
      return false;
    }
    if (!invoiceData?.patient_details?.id) {
      toast.error("Please select patient");
      return false;
    }
    if (
      billType !== "PHARMACY" &&
      isInstitutionPatient &&
      (!invoiceData?.slot_id || !invoiceData?.admission_details?.injury_no)
    ) {
      toast.error("Please select injury number");
      return false;
    }
    if (
      billType === "IPD" &&
      (!invoiceData?.admission_details?.IPD_No ||
        !invoiceData?.admission_details?.ipd_id)
    ) {
      toast.error("Please select IPD");
      return false;
    }
    if (
      billType === "OPD" &&
      (!invoiceData?.opd?.id || !invoiceData?.opd?.opd_number)
    ) {
      toast.error("Please select OPD");
      return false;
    }
    if (billType === "IPD" && !invoiceData?.admission_details?.admission_date) {
      toast.error("Please enter admission date");
      return false;
    }
    if (
      type === "submit" &&
      billType === "IPD" &&
      !invoiceData?.admission_details?.discharge_date
    ) {
      toast.error("Please enter discharge date");
      return false;
    }
    if (billType === "IPD" && !invoiceData?.admission_details?.admission_time) {
      toast.error("Please enter admission time");
      return false;
    }
    if (
      type === "submit" &&
      billType === "IPD" &&
      !invoiceData?.admission_details?.discharge_time
    ) {
      toast.error("Please enter discharge time");
      return false;
    }
    const admissionDate = moment(
      invoiceData?.admission_details?.admission_date
    );
    const dischargeDate = moment(
      invoiceData?.admission_details?.discharge_date
    );
    if (billType === "IPD" && dischargeDate.isBefore(admissionDate)) {
      toast.error("Discharge date should not be earlier than admission date");
      return false;
    }
    const invoiceDate = moment(invoiceData?.invoice_date);
    if (billType === "IPD" && invoiceDate.isBefore(admissionDate)) {
      toast.error("Invoice date should not be earlier than admission date");
      return false;
    }
    if (!invoiceData?.clinic_id) {
      toast.error("Please select billing unit");
      return false;
    }
    return true;
  };

  const submitMutation = useCreateItem(ApiEndPoint.BILLING_CREDIT_INVOICE);
  const updateInvoiceMutation = useSecureUpdateItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE
  );
  const deleteInvoiceMutation = useSecureDeleteItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE
  );

  const createPdfMutation = useCreateItem(`payments/billing/`);

  // const getTotalBatchCount = (batch_no) => {
  //   const totalBatchQty = batch_no?.reduce(
  //     (sum, batch) => sum + batch.batchQty,
  //     0
  //   );
  //   return totalBatchQty;
  // };

  // const validateQty = () => {
  //   if (billType === "PHARMACY") {
  //     for (let i of pharmacyLines) {
  //       const batchQtyTotal = getTotalBatchCount(i?.batch_no) || 0;
  //       if (Number(i?.quantity) > Number(batchQtyTotal)) {
  //         return false;
  //       }
  //     }
  //     return true;
  //   }

  //   const { invoice_lines } = invoiceData || [];
  //   for (let i = 0; i < invoice_lines?.length; i++) {
  //     const { sub_lines } = invoice_lines[i] || [];
  //     for (let j = 0; j < sub_lines?.length; j++) {
  //       const batchQtyTotal = getTotalBatchCount(sub_lines[j]?.batch_no) || 0;
  //       if (Number(sub_lines[j]?.quantity) > Number(batchQtyTotal)) {
  //         return false;
  //       }
  //     }
  //   }
  //   return true;
  // };

  const getBatchPayloadForInvoice = (invoiceLines = []) => {
    const list = JSON.parse(JSON.stringify(invoiceLines));
    for (let i of list) {
      const { sub_lines } = i;
      for (let j of sub_lines) {
        const { batch_no } = j;
        const batchIds = [];
        const batches = [];
        for (let k of batch_no) {
          batchIds.push(k?.batchId);
        }
        batches.push({
          batch_no: batchIds,
          quantity: Number(j?.quantity),
        });
        j.batch_no = batches;
      }
    }
    return list;
  };

  const getBatchPayloadForPharmacy = (pharmacyLines = []) => {
    const list = JSON.parse(JSON.stringify(pharmacyLines));
    for (let i of list) {
      const { batch_no } = i;
      const batchIds = [];
      const batches = [];
      for (let k of batch_no) {
        batchIds.push(k?.batchId);
      }
      batches.push({
        batch_no: batchIds,
        quantity: Number(i?.quantity),
      });
      i.batch_no = batches;
    }
    return list;
  };

  const getLinesPayload = () => {
    const { invoice_lines } = invoiceData || [];
    const result = [];
    for (let i = 0; i < invoice_lines?.length; i++) {
      const { sub_lines } = invoice_lines[i] || [];
      const filteredSubline = sub_lines?.filter(
        (ele) => Number(ele?.quantity) > 0
      );
      if (invoice_lines[i]?.type === "Amt") {
        result.push({ ...invoice_lines[i], sub_lines: filteredSubline });
      }
      if (
        invoice_lines[i]?.type === "Qty" &&
        Number(invoice_lines[i]?.quantity) > 0
      ) {
        result.push({ ...invoice_lines[i], sub_lines: filteredSubline });
      }
    }
    const modifiedLines = result?.map((ele) => ({
      ...ele,
      line_service: ele?.line_service?.id || null,
      line_package: ele?.line_package?.id || null,
    }));
    return getBatchPayloadForInvoice(modifiedLines);
  };

  // const handleSellout = (listOfSelectedBatches = [], totalQty) => {
  //   listOfSelectedBatches.sort((a, b) => {
  //     const dateA = new Date(a.received_date);
  //     const dateB = new Date(b.received_date);
  //     return dateA - dateB;
  //   });
  //   let total_qty = totalQty;
  //   const consumed_data = [];
  //   const updatedQty = listOfSelectedBatches.map((ele) => {
  //     const avl_batch_qty = Number(ele.inward_qty) - Number(ele.consumed_qty);
  //     let consumed_qty = ele.consumed_qty;
  //     let curr_consumed_qty = 0;
  //     if (avl_batch_qty > 0 && total_qty > 0) {
  //       if (Number(avl_batch_qty) - Number(total_qty) >= 0) {
  //         consumed_qty = Number(ele.consumed_qty) + Number(total_qty);
  //         curr_consumed_qty = Number(curr_consumed_qty) + Number(total_qty);
  //         // consumed_data.push({...ele, consumed_qty: curr_consumed_qty})
  //         total_qty = 0;
  //       } else {
  //         consumed_qty = Number(ele.consumed_qty) + Number(avl_batch_qty);
  //         curr_consumed_qty = Number(curr_consumed_qty) + Number(avl_batch_qty);
  //         // consumed_data.push({...ele, consumed_qty: curr_consumed_qty})
  //         total_qty = Number(total_qty) - Number(avl_batch_qty);
  //       }
  //     }
  //     consumed_data.push({ ...ele, consumed_qty: curr_consumed_qty });
  //     return { ...ele, consumed_qty };
  //   });
  //   return consumed_data;
  // };

  // const getBatchPayload1 = (invoiceLines = []) => {
  //   const lines = deepCopy(invoiceLines);
  //   for (let i of lines) {
  //     const { sub_lines } = i;
  //     for (let j of sub_lines) {
  //       const { batch_no } = j;
  //       const batches = [];
  //       for (let k of batch_no) {
  //         batches.push(k);
  //       }
  //       const bbb = handleSellout(batches, j?.quantity);
  //       j.batch_no = bbb;
  //     }
  //   }
  //   return lines;
  // };

  const generatePDF = async (isPublished, invoiceId) => {
    // if (isPublished || !invoiceId) {
    //   return;
    // }

    try {
      setIsPDFLoading(true);
      const URL = `payments/billing/?action=getcreatePDFInvoice&clinic_id=${clinic?.id}&backend=True&invoice_data=${invoiceId}`;
      const headerImg = getImageURL(
        doctorSettings?.header_footer_setup["A4"]?.headerUrl
      );
      const pdfData = await secureAxios.get(URL);
      const htmlContent = ReactDOMServer.renderToString(
        <InvoicePrint
          headerUrl={headerImg}
          invoice_data={invoiceData}
          pdfData={pdfData?.data?.invoiceData}
        />
      );
      setIsPDFLoading(false);
      return {
        html: htmlContent,
        // pageSize: "A4", // optional
        clinic_id: clinic?.id,
        filename: "invoice", // optional
      };
    } catch (err) {
      setIsPDFLoading(false);
      return err;
    }
  };

  const handleSave = () => {
    if (!validateInvoiceForm("save")) {
      return;
    }

    const billing_credit_payments = invoiceData?.billing_credit_payments
      ?.filter(
        (p) => p?.transaction_date?.length > 0 && p?.received_payment > 0
      )
      ?.map((bill) => ({
        ...bill,
        payment_mode: bill?.payment_mode?.id,
        received_payment: Number(bill?.received_payment),
        transaction_date: moment(bill?.transaction_date).format(
          "YYYY-MM-DDTHH:mm:ss[Z]"
        ),
        sort: 1,
      }));

    const received_payment = billing_credit_payments?.reduce(
      (acc, curr) => acc + Number(curr?.received_payment),
      0
    );

    if (invoiceData?.invoice_total < received_payment) {
      toast.error("you cannot pay more than the invoice total");
      return;
    }

    const invoiceDate = invoiceData?.invoice_date
      ? moment(invoiceData?.invoice_date).toDate()
      : moment().toDate();

    const payload = {
      action: "postBillingCreditInvoice",
      backend: "True",
      ...invoiceData,
      institution_customer: invoiceData?.institution_customer?.id,
      patient_details: invoiceData?.patient_details?.id,
      clinic_id: clinic?.id,
      invoice_lines: getLinesPayload(),
      billing_credit_payments,
      status: "draft",
      bill_type: billType,
      invoice_date: invoiceDate,
      pending_payment: 0,
      received_payment: 0,
      institution: isInstitutionPatient,
      feature_name: "invoice",
    };

    if (billType === "PHARMACY") {
      delete payload.invoice_lines;
      payload["pharmacy_lines"] = getBatchPayloadForPharmacy(pharmacyLines);
    }

    if (editId || invoiceData?.id) {
      const patchId = editId || invoiceData?.id;
      updateInvoiceMutation.mutate(
        {
          id: patchId,
          data: { ...payload, action: "patchBillingCreditInvoice" },
        },
        {
          onSuccess: (data) => {
            setInvoiceData((prev) => ({
              ...prev,
              id: data?.data?.id,
            }));
            navigate("/new/invoice?option=invoice");
          },
          onError: (data) => {
            toast.error(
              data?.response?.data?.message || data?.response?.data?.error_msg
            );
          },
        }
      );
      return;
    }
    submitMutation.mutate(payload, {
      onSuccess: (data) => {
        setInvoiceData((prev) => ({
          ...prev,
          id: data?.data?.id,
        }));
        navigate("/new/invoice?option=invoice");
      },
      onError: (data) => {
        toast.error(
          data?.response?.data?.message || data?.response?.data?.error_msg
        );
      },
    });
  };

  const handleDelete = (invoiceId) => {
    deleteInvoiceMutation.mutate(
      {
        action: "delBillingCreditInvoice",
        backend: "True",
        clinic_id: clinic?.id,
        id: invoiceId,
      },
      { onSuccess: () => navigate(-1) }
    );
  };

  const handleSubmit = async () => {
    if (!validateInvoiceForm()) {
      return;
    }
    // if (!validateQty()) {
    //   toast.error(
    //     "Batch quantity is insufficient. Please select additional batches to match the invoice quantity."
    //   );
    //   return;
    // }
    const billing_credit_payments = invoiceData?.billing_credit_payments
      ?.filter(
        (p) => p?.transaction_date?.length > 0 && p?.received_payment > 0
      )
      ?.map((bill) => ({
        ...bill,
        payment_mode: bill?.payment_mode?.id,
        received_payment: Number(bill?.received_payment),
        transaction_date: moment(bill?.transaction_date).format(
          "YYYY-MM-DDTHH:mm:ss[Z]"
        ),
        sort: 1,
      }));

    const received_payment = billing_credit_payments?.reduce(
      (acc, curr) => acc + Number(curr?.received_payment),
      0
    );

    const invoiceDate = invoiceData?.invoice_date
      ? moment(invoiceData?.invoice_date).toDate()
      : moment().toDate();

    if (invoiceData?.invoice_total < received_payment) {
      toast.error("you cannot pay more than the invoice total");
      return;
    }

    // const pdf_payload = await generatePDF(
    //   editId && invoiceData?.status === "published",
    //   editId
    // );

    let payload = {
      action: "postBillingCreditInvoice",
      backend: "True",
      ...invoiceData,
      institution_customer: invoiceData?.institution_customer?.id,
      invoice_lines: getLinesPayload(),
      patient_details: invoiceData?.patient_details?.id,
      billing_credit_payments,
      // invoice_files: uploadedImageIds?.map((file) => file?.id),
      // hold_stock: getBatchPayload(invoiceData?.invoice_lines),
      status: "published",
      invoice_date: invoiceDate,
      bill_type: billType,
      institution: isInstitutionPatient,
      feature_name: "invoice",
      // pdf_payload,
    };

    if (editId && invoiceData?.status === "published") {
      payload = {
        id: editId || invoiceData?.id,
        action: "postBillingCreditInvoice",
        backend: "True",
        billing_credit_payments,
        clinic_id: invoiceData?.clinic_id,
        feature_name: "invoice",
      };
    }

    if (billType === "PHARMACY") {
      delete payload.invoice_lines;
      payload["pharmacy_lines"] = getBatchPayloadForPharmacy(pharmacyLines);
    }

    if (editId || invoiceData?.id) {
      const patchId = editId || invoiceData?.id;
      updateInvoiceMutation.mutate(
        {
          id: patchId,
          data: {
            ...payload,
            action: "patchBillingCreditInvoice",
          },
        },
        {
          onSuccess: (data) => {
            toast.success("Submitted successfully");
            navigate(
              `/new/create_invoice?bill_type=${billType}&editId=${data?.id}`
            );
          },
          onError: (data) => {
            toast.error(
              data?.response?.data?.message || data?.response?.data?.error_msg
            );
          },
        }
      );
    } else {
      submitMutation.mutate(payload, {
        onSuccess: (data) => {
          toast.success("Submitted successfully");
          navigate(
            `/new/create_invoice?bill_type=${billType}&editId=${data?.data?.id}`
          );
        },
        // onSuccess: async (data) => {
        //   const pdf_payload = await generatePDF(false, data?.data?.id);
        //   updateInvoiceMutation.mutate(
        //     {
        //       id: data?.data?.id,
        //       data: {
        //         id: data?.data?.id,
        //         action: "patchBillingCreditInvoice",
        //         backend: "True",
        //         status: "published",
        //         clinic_id: data?.data?.clinic_id,
        //         feature_name: "invoice",
        //         pdf_payload,
        //       },
        //     },
        //     {
        //       onSuccess: (data) => {
        //         toast.success("Submitted successfully");
        //         navigate(
        //           `/new/create_invoice?bill_type=${billType}&editId=${data?.id}`
        //         );
        //       },
        //       onError: (data) => {
        //         toast.error(
        //           data?.response?.data?.message ||
        //             data?.response?.data?.error_msg
        //         );
        //       },
        //     }
        //   );
        // },
        onError: (data) => {
          toast.error(
            data?.response?.data?.message || data?.response?.data?.error_msg
          );
        },
      });
    }
    // if (editId || invoiceData?.id) {
    //   const patchId = editId || invoiceData?.id;
    //   createPdfMutation.mutate(
    //     {
    //       action: "createPdfInvoice",
    //       invoice: true,
    //       clinic_id: clinic?.id,
    //       backend: "True",
    //       upload_to: "clinics",
    //       invoice_data: Number(patchId),
    //       clinic_location: clinic?.location,
    //       clinic_name: clinic?.clinic_name,
    //     },
    //     {
    //       onSuccess: (data) => {
    //         updateInvoiceMutation.mutate(
    //           {
    //             id: patchId,
    //             data: {
    //               ...payload,
    //               pdf_invoice: data?.url,
    //               clinic_location: clinic?.location,
    //               clinic_name: clinic?.clinic_name,
    //               action: "patchBillingCreditInvoice",
    //             },
    //           },
    //           {
    //             onSuccess: (data) => {
    //               // navigate("/new/invoice?option=invoice");
    //               toast.success("Submitted successfully");
    //               navigate(
    //                 `/new/create_invoice?bill_type=${billType}&editId=${data?.id}`
    //               );
    //             },
    //             onError: (data) => {
    //               toast.error(
    //                 data?.response?.data?.message ||
    //                   data?.response?.data?.error_msg
    //               );
    //             },
    //           }
    //         );
    //       },
    //       onError: (data) => {
    //         toast.error(data?.response?.data?.message);
    //       },
    //     }
    //   );
    //   // return;
    // } else {
    //   createPdfMutation.mutate(
    //     {
    //       action: "createPdfInvoice",
    //       clinic_id: clinic?.id,
    //       invoice: true,
    //       backend: "True",
    //       upload_to: "clinics",
    //       invoice_data: { ...invoiceData, bill_type: billType },
    //       clinic_location: clinic?.location,
    //       clinic_name: clinic?.clinic_name,
    //     },
    //     {
    //       onSuccess: (data) => {
    //         submitMutation.mutate(
    //           { ...payload, pdf_invoice: data?.url },
    //           {
    //             onSuccess: (data) => {
    //               // navigate("/new/invoice?option=invoice");
    //               toast.success("Submitted successfully");
    //               navigate(
    //                 `/new/create_invoice?bill_type=${billType}&editId=${data?.data?.id}`
    //               );
    //             },
    //             onError: (data) => {
    //               toast.error(
    //                 data?.response?.data?.message ||
    //                   data?.response?.data?.error_msg
    //               );
    //             },
    //           }
    //         );
    //       },
    //       onError: (data) => {
    //         toast.error(data?.response?.data?.message);
    //       },
    //     }
    //   );
    // }
  };

  const handleFocus = (id) => {
    document.getElementById(id).focus();
  };

  const createBlankPayment = () => {
    setInvoiceData((prev) => {
      const blankRow = {
        status: "Paid",
        received_payment: 0,
        transaction_date: "",
        transaction_details: "",
        payment_mode: { id: 2, type: "By cash" },
      };
      const temp = [...prev?.billing_credit_payments, blankRow];
      return { ...prev, billing_credit_payments: temp };
    });
  };

  const handlePaymentChange = (value, label, idx) => {
    setInvoiceData((prev) => {
      const temp = [...prev?.billing_credit_payments];
      temp[idx][label] = value;
      return { ...prev, billing_credit_payments: temp };
    });
  };

  const deletePayment = (idx) => {
    if (invoiceData?.billing_credit_payments?.length > 1) {
      setInvoiceData((prev) => {
        const temp = [...prev?.billing_credit_payments];
        temp?.splice(idx, 1);
        return { ...prev, billing_credit_payments: temp };
      });
    } else {
      setInvoiceData((prev) => {
        return {
          ...prev,
          billing_credit_payments: initialState?.billing_credit_payments,
        };
      });
    }
  };

  const handlePrint = () => {
    if (isPrint) {
      toast.warning("Please wait your last request is in process");
      return;
    }

    // Removed the EditId from here
    if (invoiceData?.status === "published") {
      setIsPrint(true);
    } else {
      toast.error("You can only print published invoice");
    }
  };

  const handleSend = () => {
    if (invoiceData?.status === "published" && editId) {
      generatePDF("", editId)
        .then((pdfPayload) => {
          const payload = {
            action: "createPdfInvoice",
            clinic_id: clinic?.id,
            backend: "True",
            pdf_payload: pdfPayload,
          };

          createPdfMutation.mutate(payload, {
            onSuccess: (data) => {
              setIsSend({
                flag: true,
                invoicePdf: [
                  {
                    url: data?.url,
                    fileName: "invoice.pdf",
                  },
                ],
              });
            },
            onError: (err) => {
              toast.error(JSON.stringify(err));
            },
          });
        })
        .catch((err) => toast.error(JSON.stringify(err)));
    }
  };

  return (
    <>
      <div className="cu-invoice-container">
        <div className="cu-create-invoice-main">
          <div className="sticky top-0 left-0 z-10 bg-white">
            {viewId && (
              <div className="w-full pt-3  top-0 ">
                <div className="flex border-b-2 pb-3">
                  <span className="inline-flex rounded-2xl items-center bg-yellow-50 px-2 py-1 font-small text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                    <FaEye size={20} className="mr-3" />
                    View Mode
                  </span>
                  <span className="px-2 py-1 font-small text-gray-600">
                    You're currently in view mode. To make changes, please
                    switch to edit mode by{" "}
                    <a
                      className="underline cursor-pointer"
                      onClick={() =>
                        navigate(
                          `/new/create_invoice?editId=${viewId}&bill_type=${billType}`
                        )
                      }
                    >
                      clicking here.
                    </a>
                  </span>
                </div>
              </div>
            )}
            <div className="cu-create-invoice-menu">
              {INVOICE_MENU_OPTIONS.map((option) => (
                <div
                  key={option.id}
                  onClick={() => handleFocus(option?.eleId)}
                  className="cu-create-invoice-menu-item"
                >
                  {option.label}
                </div>
              ))}
            </div>
          </div>
          <div className="cu-create-invoice-sec-1">
            <div className="cu-create-invoice-general-info">
              {billType !== "PHARMACY" ? (
                <GeneralInfo
                  displayData={invoiceData}
                  handleChange={handleChange}
                  setIsInstitutionPatient={setIsInstitutionPatient}
                  isInstitutionPatient={isInstitutionPatient}
                  billType={billType}
                  isView={viewId ? true : false}
                  throwAppointment={throwAppointment}
                  viewId={viewId}
                  editId={editId}
                  setInvoiceData={setInvoiceData}
                />
              ) : (
                <PGeneralInfo
                  displayData={invoiceData}
                  handleChange={handleChange}
                  setIsInstitutionPatient={setIsInstitutionPatient}
                  isInstitutionPatient={isInstitutionPatient}
                  billType={billType}
                  isView={viewId ? true : false}
                  throwAppointment={throwAppointment}
                  viewId={viewId}
                  editId={editId}
                  setInvoiceData={setInvoiceData}
                />
              )}
            </div>
            <div className="cu-create-invoice-admit-cust-info">
              <div className="cu-create-invoice-admission-details">
                <AdmissionDetails
                  handleChange={handleChange}
                  value={invoiceData?.admission_details}
                  billingUnit={invoiceData?.clinic_id}
                  isView={viewId ? true : false}
                  isInstitutionPatient={isInstitutionPatient}
                  billType={billType}
                />
              </div>
              <div className="cu-create-invoice-customer-info">
                <CustomerInfo
                  customerInfo={invoiceData?.institution_customer}
                  isInstitutionPatient={isInstitutionPatient}
                  patientInfo={invoiceData?.patient_details}
                />
              </div>
            </div>
          </div>
          <div className="cu-create-invoice-line-heading">
            <div className="cu-invoice-lines-icon">
              <span>
                <img
                  src={cufrontIcons.line}
                  width={"33.6px"}
                  height={"26px"}
                  alt="line"
                />
              </span>
              <span className="cu-create-invoice-heading-text">Lines</span>
            </div>
            <div className="cu-invoice-lines-discount">
              <input
                type="checkbox"
                checked={lineLevelDisc}
                onChange={() => {}}
                onClick={() => setLineLevelDisc((prev) => !prev)}
                disabled={viewId ? true : false}
              />
              <span className="cu-invoice-lines-discount-text">
                Line Level Discount
              </span>
            </div>
          </div>
          <div className="cu-create-invoice-lines">
            {billType !== "PHARMACY" &&
              invoiceData?.invoice_lines?.map((line, idx) => (
                <Lines
                  key={idx}
                  lineLevelDisc={lineLevelDisc}
                  isView={viewId ? true : false}
                  throwAppointment={throwAppointment}
                  setInvoiceData={setInvoiceData}
                  invoiceData={invoiceData}
                  line={line}
                  idx={idx}
                  calculateAllTotal={calculateTotal}
                />
              ))}
            {billType === "PHARMACY" &&
              pharmacyLines?.map((pline, idx) => (
                <PLine
                  key={idx}
                  pline={pline}
                  idx={idx}
                  handlePLineChange={() => {}}
                  handleSelectMedicine={() => {}}
                  isView={viewId ? true : false}
                  handleSelectPLineUom={() => {}}
                  setPharmacyLines={setPharmacyLines}
                  pharmacyLines={pharmacyLines}
                  lineLevelDisc={lineLevelDisc}
                  invoiceData={invoiceData}
                  setInvoiceData={setInvoiceData}
                  deletePLine={() => {}}
                  handleSelectBatch={() => {}}
                />
              ))}
          </div>
          <div className="cu-create-invoice-grand-total">
            <TotalCount
              displayData={invoiceData}
              handleChange={handleChange}
              isView={viewId ? true : false}
            />
          </div>
          <div className="cu-create-invoice-line-cum">
            <CuM
              isView={viewId ? true : false}
              showUserList={showUserList}
              setShowUserList={setShowUserList}
              comment={comment}
              setComment={setComment}
            />
          </div>
          <div className="cu-create-invoice-line-payments">
            <div className="cu-general-info-heading">
              <span>
                <img
                  style={{ width: "40px", height: "24px" }}
                  src={cufrontIcons.payment}
                  alt=""
                />
              </span>
              <span>Payment</span>
            </div>
            {invoiceData?.billing_credit_payments?.map((payment, idx) => {
              return (
                <Payment
                  key={idx}
                  idx={idx}
                  handlePaymentChange={handlePaymentChange}
                  payment={payment}
                  invoiceStatus={invoiceData?.status}
                  deletePayment={deletePayment}
                  createBlankPayment={createBlankPayment}
                  paymentOptions={options?.payment}
                  isView={viewId ? true : false}
                />
              );
            })}
          </div>
          <div className="cu-invoice-button-cont">
            <CustomButton
              color={"white"}
              className={"cu-invoice-button-main cursor-pointer"}
              onClick={() => handleDelete(invoiceData?.id)}
              loading={deleteInvoiceMutation.isLoading}
              disabled={!(invoiceData?.id && invoiceData?.status === "draft")}
            >
              Delete
            </CustomButton>
            <CustomButton
              color={"white"}
              className={"cu-invoice-button-main cursor-pointer"}
              onClick={() => navigate("/new/invoice?option=invoice")}
            >
              Close
            </CustomButton>
            {invoiceData?.status === "draft" && (
              <CustomButton
                color={"white"}
                className={"cu-invoice-button-main cursor-pointer"}
                onClick={handleSave}
                loading={
                  submitMutation.isLoading || updateInvoiceMutation.isLoading
                }
              >
                Save
              </CustomButton>
            )}
            {editId && invoiceData?.status === "published" && (
              <CustomButton
                color={"white"}
                className={"cu-invoice-button-main cursor-pointer"}
                onClick={handleSubmit}
                loading={updateInvoiceMutation.isLoading}
              >
                Edit
              </CustomButton>
            )}
            {invoiceData?.status === "draft" && (
              <CustomButton
                color={"#EBF8EC"}
                className={"cu-invoice-button-main"}
                onClick={handleSubmit}
                loading={
                  submitMutation.isLoading ||
                  updateInvoiceMutation.isLoading ||
                  isPDFLoading
                }
              >
                Submit
              </CustomButton>
            )}
            <CustomButton
              color={"white"}
              className={"cu-invoice-button-main"}
              onClick={handleSend}
              loading={isPDFLoading || createPdfMutation.isLoading}
              // disabled={!(invoiceData?.status === "published")}
            >
              Send
            </CustomButton>
            <CustomButton
              color={"white"}
              className={"cu-invoice-button-main"}
              onClick={handlePrint}
              // disabled={!(invoiceData?.status === "published")}
            >
              Print
            </CustomButton>
          </div>
        </div>
        <div className="cu-invoice-icon-cont">
          <div className="cu-invoice-drop-icon">
            <div
              style={{ width: "24px", height: "17px" }}
              onClick={() => setShowIcon(!showIcon)}
            >
              {showIcon && (
                <MdExpandLess size={35} className="cursor-pointer" />
              )}
              {!showIcon && (
                <MdExpandMore size={35} className="cursor-pointer" />
              )}
            </div>
          </div>
          {showIcon && (
            <div className="cu-invoice-icon-div">
              {/* <div style={{ width: "24px", height: "24px" }}>
                <img src={cufrontIcons.scanner} alt="" />
              </div> */}
              <div
                style={{ width: "15px", height: "24px" }}
                onClick={() => setIsUpload(true)}
              >
                <img src={cufrontIcons.pin} alt="" />
              </div>
              {/* <div style={{ width: "20px", height: "20px" }}>
                <img src={cufrontIcons.timer} alt="" />
              </div> */}
            </div>
          )}
        </div>
        {isUplaod && (
          <CuModal>
            <InvoiceAttachment
              setIsUpload={setIsUpload}
              setUploadedImageIds={setUploadedImageIds}
              uploadedImageIds={uploadedImageIds}
            />
          </CuModal>
        )}
        {isSend?.flag && (
          <CuModal>
            <BillingEmail
              setIsSend={setIsSend}
              email={invoiceData?.institution_customer?.email_address}
              customerName={invoiceData?.institution_customer?.institution_name}
              invoicePdf={isSend?.invoicePdf}
              type={"invoice"}
              title={"Invoice"}
              subject={`Attention ${invoiceData?.institution_customer?.institution_name} Your invoice is ready`}
            />
          </CuModal>
        )}
        {isPrint &&
          (billType !== "PHARMACY" ? (
            <EmailTemplate
              invoiceData={invoiceData}
              closeModal={() => setIsPrint(false)}
              isPrint={isPrint}
            />
          ) : (
            <PInvoicePrint
              invoiceData={invoiceData}
              pharmacyLines={pharmacyLines}
              isPrint={isPrint}
              closeModal={() => setIsPrint(false)}
            />
          ))}
      </div>
    </>
  );
};

export default InvoiceForm;
